import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/contexts/AuthContext';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Loader2 } from 'lucide-react';

const Legislature = () => {
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const [legislature, process, history] = await Promise.all([
        axios.get(`${API}/content/legislature`),
        axios.get(`${API}/content/process`),
        axios.get(`${API}/content/history`)
      ]);

      const allContent = [
        { section: 'Understanding the Legislature', items: legislature.data },
        { section: 'Legislative Process', items: process.data },
        { section: 'History of the National Assembly', items: history.data }
      ];

      setContent(allContent);
    } catch (error) {
      console.error('Error fetching content:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary-700" />
      </div>
    );
  }

  return (
    <div className="py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <h1 className="font-heading text-4xl md:text-5xl font-semibold text-slate-900 mb-4">
            Understanding the Legislature
          </h1>
          <p className="text-lg text-slate-600">
            Learn about the structure, roles, and functions of Nigeria's National Assembly
          </p>
        </div>

        <div className="space-y-12">
          {content.map((section, sectionIndex) => (
            <div key={sectionIndex}>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-slate-900 mb-6">
                {section.section}
              </h2>
              
              {section.items.length > 0 ? (
                <Accordion type="single" collapsible className="space-y-4">
                  {section.items.map((item, itemIndex) => (
                    <AccordionItem 
                      key={item.id} 
                      value={item.id}
                      className="bg-white border border-slate-200 rounded-xl px-6 shadow-sm hover:shadow-md transition-shadow"
                    >
                      <AccordionTrigger 
                        className="text-left font-semibold text-slate-900 hover:text-primary-700 py-4"
                        data-testid={`accordion-trigger-${sectionIndex}-${itemIndex}`}
                      >
                        {item.title}
                      </AccordionTrigger>
                      <AccordionContent className="text-slate-600 leading-relaxed pb-4 whitespace-pre-line">
                        {item.content}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              ) : (
                <div className="bg-surface rounded-xl p-8 text-center">
                  <p className="text-slate-600">No content available for this section.</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Legislature;
